module.exports = __webpack_public_path__ + "static/media/cake-two.e4bbcb14.png";